import FormPage from '@/pages/form';
import NotFound from '@/pages/not-found';
import { Suspense, lazy } from 'react';
import { Navigate, Outlet, useRoutes } from 'react-router-dom';

const DashboardLayout = lazy(
  () => import('@/components/layout/dashboard-layout')
);
const DashboardPage = lazy(() => import('@/pages/dashboard'));
const StudentPage = lazy(() => import('@/pages/students'));
const StudentDetailPage = lazy(
  () => import('@/pages/students/StudentDetailPage')
);
const OverviewPage = lazy(() => import('@/pages/overview/index'));
const AnalyticsPage = lazy(() => import('@/pages/analytics/index'));
const SettingsPage = lazy(() => import('@/pages/settings/index'));
const ConsumablesPage = lazy(() => import('@/pages/consumables/index'));
const EventsPage = lazy(() => import('@/pages/events/index'));
const NotificationsPage = lazy(() => import('@/pages/notifications/index'));

// ----------------------------------------------------------------------

export default function AppRouter() {
  const routes = [
    {
      path: '/',
      element: (
        <DashboardLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      ),
      children: [
        {
          element: <DashboardPage />,
          index: true
        },
        {
          path: 'analytics',
          element: <AnalyticsPage />
        },
        {
          path: 'overview',
          element: <OverviewPage />
        },
        {
          path: 'events',
          element: <EventsPage />
        },
        {
          path: 'student',
          element: <StudentPage />
        },
        {
          path: 'student/details',
          element: <StudentDetailPage />
        },
        {
          path: 'form',
          element: <FormPage />
        },
        {
          path: 'notifications',
          element: <NotificationsPage />
        },
        {
          path: 'settings',
          element: <SettingsPage />
        },
        {
          path: 'consumables',
          element: <ConsumablesPage />
        }
      ]
    },
    {
      path: '/404',
      element: <NotFound />
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />
    }
  ];

  return useRoutes(routes);
}
